import type { KuxFilteredCategoriesDTO } from '../interfaces';

export const categoryTreeItemsMap = new Map<string, KuxFilteredCategoriesDTO>();
